import * as React from "react";
import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useNavigate,
} from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import Performance from "./performance";
import SupplierDashboard from "./supplier";
import Header from "../components/common/header";
import Opportunities from "./opportunities";
import NiaNegotiations from "./niaNegotiations";
import PortfolioGap from "./portfolioGap";
import CategoryProfitability from "./category-profitability";
import NextTier from "./nextTier";
import SupplierConsolidation from "./supplierConsolidation";
import CostOptimization from "./costOptimization";
import NIASimulator from "./niaSimulator";
import SkuManagementNew from "./skuManagement";
import Pricing from "./pricing";
import PricingNew from "./pricingNew";
import CrossSellNew from "./crossSellNew";
import { CrossSell } from "./crossSell";
import CategoryBaseline from "./category-baseline";
import ParametricAnalysis from "./parametricAnalysis";
import HomePage from "./home";
import SkuManagement from "./skuManagementNew";
import PreferredSupplier from "./preferredSupplier";
import ValueCapture from "./valueCapture";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
	ApplicationInsights,
	ITelemetryPlugin,
} from "@microsoft/applicationinsights-web";
import { INSTRUMENTATION_KEY } from "../config/config";
import MainLayout from "../components/Layouts/MainLayout";
import Alerts from "./alerts";
import CategoryProgressTracker from "./categoryProgressTracker";
import ProgressTrackerCategory from "./progressTrackerCategory";
import CategoryPerformance from "./categoryPerformance";
import "../scss/dropdown.scss";
import MarginPreservationDashboard from "./marginPreservationDashboard";
import IndustryInsights from "./industryInsights";

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
		disableFetchTracking: false,
		enableAutoRouteTracking: true,
		extensions: [reactPlugin as unknown as ITelemetryPlugin],
		autoTrackPageVisitTime: true,
	},
});
appInsights.loadAppInsights();

const Router = () => {
	const isAuthenticated = useIsAuthenticated();
	return (
		<BrowserRouter>
			<Header />
			<Routes>
				<Route
					path="/profitability"
					element={
						<MainLayout>
							<CategoryProfitability />
						</MainLayout>
					}
				/>
				<Route
					path="/supplier"
					element={
						<MainLayout>
							<SupplierDashboard />
						</MainLayout>
					}
				/>
				<Route
					path="/performance"
					element={
						<MainLayout>
							<Performance />
						</MainLayout>
					}
				/>
				<Route
					path="/cost-optimization"
					element={
						<MainLayout>
							<CostOptimization />
						</MainLayout>
					}
				/>
				<Route
					path="*"
					element={
						<MainLayout>
							<Navigate replace={true} to="/home" />
						</MainLayout>
					}
				/>
				<Route
					path="/"
					element={
						<MainLayout>
							<Navigate replace={true} to="/home" />
						</MainLayout>
					}
				/>
				<Route
					path="/home"
					element={
						<MainLayout>
							<HomePage />
						</MainLayout>
					}
				/>
				<Route
					path="/opportunities"
					element={
						<MainLayout>
							<Opportunities />
						</MainLayout>
					}
				/>
				<Route
					path="/nia-negotiations"
					element={
						<MainLayout>
							<NiaNegotiations />
						</MainLayout>
					}
				/>
				<Route
					path="/portfolio"
					element={
						<MainLayout>
							<PortfolioGap />
						</MainLayout>
					}
				/>
				<Route
					path="/next-tier"
					element={
						<MainLayout>
							<NextTier />
						</MainLayout>
					}
				/>
				<Route
					path="/nia-simulator"
					element={
						<MainLayout>
							<NIASimulator />
						</MainLayout>
					}
				/>
				<Route
					path="/supplier-consolidation"
					element={
						<MainLayout>
							<SupplierConsolidation />
						</MainLayout>
					}
				/>
				{/* <Route path="/sku-management" element={ <MainLayout><SkuManagementNew /></MainLayout>} /> */}
				<Route
					path="/sku-management"
					element={
						<MainLayout>
							<SkuManagement />
						</MainLayout>
					}
				/>
				<Route
					path="/pricing-new"
					element={
						<MainLayout>
							<Pricing />
						</MainLayout>
					}
				/>
				<Route
					path="/pricing"
					element={
						<MainLayout>
							<PricingNew />
						</MainLayout>
					}
				/>
				<Route
					path="/cross-sell"
					element={
						<MainLayout>
							<CrossSell />
						</MainLayout>
					}
				/>
				<Route
					path="/cross-sell-new"
					element={
						<MainLayout>
							<CrossSellNew />
						</MainLayout>
					}
				/>
				<Route
					path="/baseline"
					element={
						<MainLayout>
							<CategoryBaseline />
						</MainLayout>
					}
				/>
				<Route
					path="/parametric-analysis"
					element={
						<MainLayout>
							<ParametricAnalysis />
						</MainLayout>
					}
				/>
				<Route
					path="/preferredSupplier"
					element={
						<MainLayout>
							<PreferredSupplier />
						</MainLayout>
					}
				/>
				<Route
					path="/value-capture"
					element={
						<MainLayout>
							<ValueCapture />
						</MainLayout>
					}
				/>
				<Route
					path="/category-performance"
					element={
						<MainLayout>
							<CategoryPerformance />
						</MainLayout>
					}
				/>
				<Route
					path="/alerts"
					element={
						<MainLayout>
							<Alerts />
						</MainLayout>
					}
				/>
				<Route
					path="/category-progress-tracker"
					element={
						<MainLayout>
							<CategoryProgressTracker />
						</MainLayout>
					}
				/>
				<Route
					path="/progress-tracker-category"
					element={
						<MainLayout>
							<ProgressTrackerCategory />
						</MainLayout>
					}
				/>
				<Route
					path="/margin-preservation"
					element={
						<MainLayout>
							<MarginPreservationDashboard />
						</MainLayout>
					}
				/>
				<Route
					path="/industry-insights"
					element={
						<MainLayout>
							<IndustryInsights />
						</MainLayout>
						}
				/>
			</Routes>
		</BrowserRouter>
	);
};

export default Router;
